export class CourseFilter {
    name: string;
    school_year: number;
    type: any;
    status: string;
    page: number;
    limit: number;

    constructor() {
        this.name = "";
        this.type = 0;
        this.status = "";
        this.page = 1;
        this.limit = 100;
    }
}


// WEBPACK FOOTER //
// ./src/holiday/models/CourseFilter.ts